import i18next from '../../config/i18next';

i18next.addResources('es', 'ErrorPage', {
  Title: 'Error de autorización',
  Subtitle: 'Error 400: invalid_request',
  Description: 'Comunicate con mesa de ayuda',
  Ayuda: 'Ayuda',
  Privacidad: 'Privacidad',
  Terminos: 'Términos',
});

export default i18next;
